import React from 'react';

/**
 * Barra de contadores globales (Empresas · Activas · Empleados · Admins).
 *
 * @param {Array<{label:string, value:node, tone?:'ok'|'brand'|'warn'|'danger'|'muted'}>} items
 */
const TONE_COLOR = {
  ok: 'var(--ok)',
  brand: 'var(--brand-2)',
  warn: 'var(--warn)',
  danger: 'var(--danger)',
  muted: 'var(--muted)',
};

const Counters = ({ items = [], className = '', ...rest }) => (
  <div className={['a2-counters', className].filter(Boolean).join(' ')} {...rest}>
    {items.map((it, i) => (
      <React.Fragment key={it.label}>
        {i > 0 ? <div className="a2-counter-sep" /> : null}
        <div>
          <div
            className="a2-counter-value"
            style={it.tone ? { color: TONE_COLOR[it.tone] } : undefined}
          >
            {it.value}
          </div>
          <div className="a2-counter-label">{it.label}</div>
        </div>
      </React.Fragment>
    ))}
  </div>
);

export default Counters;
